jQuery(document).ready(function(jQuery) {

	jQuery('.o-que-fazemos').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerPadding: '20px',
		centerMode: true,
		responsive: [
			{
		      breakpoint: 992,
		      settings: {
		        arrows: true,
		        centerMode: true,
		        centerPadding: '0',
		        slidesToShow: 1,
		        autoplay: true,
  				autoplaySpeed: 5000,
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: true,
		        centerMode: true,
		        centerPadding: '0',
		        slidesToShow: 1,
		        autoplay: true,
  				autoplaySpeed: 3000,
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: true,
		        centerMode: true,
		        centerPadding: '0',
		        slidesToShow: 1,
		        autoplay: true,
  				autoplaySpeed: 3000,
		      }
		    }
		  ]
	});


	
	jQuery( ".ori-button.less-custom" ).parent().hide();

	jQuery( ".ori-button.more-custom" ).on( "click", function() {
		event.preventDefault();

		var totalItems = jQuery('#portfolio .vc_pageable-slide-wrapper .vc_grid-item').length;
		var visibleItems = jQuery('#portfolio .vc_pageable-slide-wrapper .vc_grid-item.vc_visible-item').length;
		var increaseItems = visibleItems + 4;

		jQuery('#portfolio .vc_pageable-slide-wrapper .vc_grid-item').slice(visibleItems,increaseItems).removeClass('fadeOut').addClass('vc_visible-item fadeIn animated removivel');

		var numItems = jQuery('.removivel').length;
		if ( numItems > 0 ) {
			jQuery( ".ori-button.less-custom" ).parent().show();
		}

		if ( totalItems == visibleItems ) {
			jQuery(this).parent().hide();
		}
	});

	jQuery( ".ori-button.less-custom" ).on( "click", function() {
		event.preventDefault();
		if(!jQuery( ".ori-button.more-custom" ).parent().is(':visible')) {
			jQuery( ".ori-button.more-custom" ).parent().show();
		}
		// jQuery('#portfolio .vc_pageable-slide-wrapper .vc_grid-item:gt(-5)').removeClass('vc_visible-item fadeIn animated removivel');
		jQuery('#portfolio .vc_pageable-slide-wrapper .vc_grid-item.removivel').addClass('fadeOut').removeClass('fadeIn removivel vc_visible-item');
		var numItems = jQuery('.removivel').length;
		if ( numItems == 0 ) {
			jQuery(this).parent().hide();
		}
	});

});